import { ColDef } from "ag-grid-community";
import { keyInsensitiveComparatorFn } from "@/components/pages/common/ag-grid/utils/helpers/sortingFunctions/keyInsensitiveComparatorFn";
import { DashboardAllItemsNameInnerRenderer } from "@/components/pages/dashboard-all-items/components/table/components/cells/DashboardAllItemsNameInnerRenderer";
import {
  DashboardFolderWithChildren,
  PartialDashboard,
} from "@/components/pages/dashboard-all-items/components/table/utils/types/types";
import { Dashboard } from "@/services/cloudchipr.api";
import { DashboardAllItemsActionCellRenderer } from "@/components/pages/dashboard-all-items/components/table/components/cells/DashboardAllItemsActionCellRenderer";
import {
  hierarchyAllItemsNameFilterValueGetter,
  hierarchyAllItemsNameValueGetter,
} from "@/components/pages/common/hierarchy-all-items/utils/helpers/valueGetters";
import { hierarchyAllItemsColDef } from "@/components/pages/common/hierarchy-all-items/components/hierarchyAllItemsColDef";
import { agGridActionColumnDefaultColumnDef } from "@/components/pages/common/ag-grid/utils/constants/agGridActionColumnDefaultColumnDef";

export const dashboardAllItemsAutoGroupColumnDef: ColDef<
  Dashboard | DashboardFolderWithChildren
> = {
  headerName: "Name",
  field: "name",
  minWidth: 300,
  suppressKeyboardEvent: () => true,
  cellRendererParams: {
    suppressCount: true,
    innerRenderer: DashboardAllItemsNameInnerRenderer,
  },
  comparator: keyInsensitiveComparatorFn,
  valueGetter: hierarchyAllItemsNameValueGetter,
  filterValueGetter: hierarchyAllItemsNameFilterValueGetter,
};

export const dashboardAllItemsColDef: ColDef<
  PartialDashboard | DashboardFolderWithChildren
>[] = [
  ...hierarchyAllItemsColDef,

  {
    ...agGridActionColumnDefaultColumnDef,
    colId: "actions",
    maxWidth: 70,
    width: 70,
    minWidth: 70,
    cellDataType: false,
    cellRenderer: DashboardAllItemsActionCellRenderer,
  } as ColDef,
];
